/**
 * This widget will convert a simple select list into a combobox designed for multiple options.
 * This is not a regular combobox which limits to the select input, this is a combobox that allows
 * data to be typed that doesn't exist in the select element.
 *
 * The typed in data can be validated to require a certain value.
 *
 * Give a select element with:
 *
 * <select id="selectElementID">
 * 	<option value="value1">Option 1</option>
 * 	<option value="value2" selected="selected">Option 2</option>
 * </select>
 *
 * Calling:
 *
 * 	$('#selectElementID').comboBox({
 * 		filter: function(value) { return value; }...
 * 	});
 *
 * Options:
 * 		canHaveNew 		(bool):		Does this combo box accept new entries?  If false, then when an invalid entry is entered it will be switched to another
 * 		canHaveEmpty 	(bool):		Does this combo box accept blank entries? If an entry is required, then the first one will be defaulted to
 * 		delay			(int):		When typing in the input box, this is a time length before the menu appears (see autocomplete documentation)
 * 		filter			(function):	A function that is used to clean/validate the entered text. Accepts one param, the text entered into the combobox, and it must return
 * 									a string which will replace the contents of the text box. If it matches the text of an exisiting option, then that wlil be selected. Otherwise
 * 									"__new" will be marked (if able). If the function returns a null or blank string then "__empty" will be set (if able).
 * 		minLength		(int):		The number of characters to wait before showing the drop down menu. On larger selects, this is advisable to perform initial filtering.
 * 		inheritClasses	(mixed):	Whether or not the new input & button will inherit the classes applied to the parent selector. true = both, false = none, otherwise use "input" or "button"
 * 		renderMenu		(function):	A function to override the default menu rendering. See the function _acRenderMenu to see how this works (generally left alone)
 * 		renderItem		(function):	A function to override the default item rendering. See the function _acRenderItem to see how this works. Used to override the display in the drop down menu.
 * 		sourceFilter	(string):	A selector string used to filter the <option> elements. Defaults to preventing :disabled elements from showing up. Set to "option" to allow all.
 * 		label			(object):	{
 * 										head: (string) Label to show above the elements in a drop down. Leave blank to disable.
 * 										foot: (string) Label to show below the elements in a drop down. Leave blank to disable.
 * 										blank: (string) Label to show when the user types an element that doesn't exist. Defaults to "No item exists" but can be used to explain about adding new items.
 *  								}
 *
 *  	With the label option it alternatively accepts a single string:
 *
 *  	label: 'My header'
 *
 *  	This converts to:
 *
 *  	label: {
 *  		head: 'My header',
 *  		foot: '',
 *  		blank: 'No item exists'
 *  	}
 *
 * Makes:
 * 	1) An input box and a button. The input box runs autocomplete, and the button triggers the autocomplete.
 *
 * See also http://docs.jquery.com/UI_Developer_Guide#The_widget_factory
 *
 */
(function($){
	$.widget( "ui.comboBox", {
		// Default options
		options: {
			canHaveNew: false,
			canHaveEmpty: false,
			delay: 0,
			filter: false,
			minLength: 0,
			inheritClasses: true,
			renderMenu: false,
			renderItem: false,
			sourceFilter: "option:not(:disabled)",
			label: '',
			onlySelect: false,
            events: {
                change: function(event){},
            }
		},

		/**
		 * Called whenever the options are changed, it will fix any funky defaults
		 */
		_fixOptions: function(){
			if(typeof this.options.label != 'object'){
				this.options.label = {
					head: this.options.label,
					foot: '',
					blank: 'No item exists'
				};
			}
		},

		/**
		 * Create the widget
		 */
		_create: function(){
			this.parentField = this.element.hide();
			var self = this;

			// Make sure this element hasn't been created yet
			if(this.parentField.hasClass('combo_d'))
				return true;

			// Fix the options
			this._fixOptions();

			// Mark the parent element as combo'd
			this.parentField.addClass('combo_d');
			if(typeof this.parentField.data('canhaveempty') != 'undefined'){
				this.options.canHaveEmpty = this.parentField.data('canhaveempty');
			}

			if(typeof this.parentField.data('canhavenew') != 'undefined'){
				this.options.canHaveNew = this.parentField.data('canhavenew');
			}

			// Build the default messages
			this._buildDefaultMessages();

			// Generate the Ids
			this._generateCurrentIds();

			// Build the elements
			this._buildElements();

			// Assign autocomplete
			this.input.autocomplete({
				delay: this.options.delay,
				minLength: this.options.minLength,
				source: this._acSourceFunction,
				position: {
					collision: 'flip'
				},
				select: function(event, ui){
					var myAutoComplete = $(this).data('autocomplete');
					setTimeout(function() {
						ui.item.option.selected = true;
						myAutoComplete._trigger('selected', event, {
							item: ui.item.option
						});

						// Change
						myAutoComplete.cbb_validation(event, ui);
						myAutoComplete.element.blur();
						$(ui.item.option).attr('selected', 'selected');
						myAutoComplete.cbb_parentField.change();

						// Callback Event
						if($.isFunction(myAutoComplete.cbb_options.events.change)) {
							myAutoComplete.cbb_options.events.change(event, ui);
							myAutoComplete.element.change();
						}
					}, 100)
				},
				change: function(event, ui){
					$(this).data('autocomplete').cbb_validation(event, ui);
					//$(this).data('autocomplete').cbb_parentField.change();
				},
				close: function(event, ui){
					$(this).data('autocomplete').cbb_button.removeClass('ui-state-focus');
					$(this).data('autocomplete').element.addClass('ui-corner-left').removeClass('ui-corner-tl');
				},
				open: function(event, ui){
					$(this).data('autocomplete').element.removeClass('ui-corner-left').addClass('ui-corner-tl');
				}
			}).val('').autocomplete('widget').addClass('combobox-widget');

			// Open the menu when the button is clicked
			this.button.bind('click.combobox', {input:this.input}, function(event){
				// When the button is clicked, show the input
				if(event.data.input.autocomplete('widget').is(':visible')){
					event.data.input.autocomplete('close');
					return true;
				}

				event.data.input.autocomplete('search', '');
				event.data.input.focus();
			});

			// Make sure the events are assigned
			this._buildSourceFunc();

			// Load default text
			this.refreshText();

			// Listen for change events on the select, refresh widget
			this.parentField.bind('change', function(event, otherParams){
				self.refreshText(); // update value in input
				self.input.next('.text-printview').html(self.input.val());
			});
		},

		/**
		 * Build the messages based on the defaults
		 */
		_buildDefaultMessages: function(){
			if(this.options.blankMessage == '__none'){
				this.options.blankMessage = (this.options.canHaveNew ? 'New item will be added' : 'No item found, please try again');
			}
		},

		/**
		 * Generate a unique ID for the input & button elements and store them in the this._ids object
		 */
		_generateCurrentIds: function(){
			if(this.parentField.prop('id').length == 0){
				// No attached ID, make one up
				this._ids = {
					input: 'cbb-' + ($('.combo_d').length + 1) + '-input',
					button: 'cbb-' + ($('.combo_d').length + 1) + '-button',
					wrapper: 'cbb-' + ($('.combo_d').length + 1) + '-wrapper'
				};
			}
			else {
				// There is an attached ID
				this._ids = {
					input: this.parentField.attr('id') + '-input',
					button: this.parentField.attr('id') + '-button',
					wrapper: this.parentField.attr('id') + '-wrapper'
				};
			}
		},

		/**
		 * Will return the classes that should be appended to the combo box based on the
		 * set options
		 * @param string elementType
		 */
		_getInheritedClasses: function(elementType){
			if(this.options.inheritClasses == true || this.options.inheritClasses == elementType){
				return this.parentField.attr('class');
			}
		},

		/**
		 * Build the actual input & button elements
		 */
		_buildElements: function(){
			if($('#' + this._ids.wrapper).length > 0){
				$('#' + this._ids.wrapper).remove();
			}
			this.wrapper = $('<div class="combobox-input-wrapper" id="' + this._ids.wrapper + '"></div>')
				.insertBefore(this.parentField)
                .alerts();

			// Input Element
			this.input = $('<input type="text" autocomplete="off" class="combobox combobox-input ui-widget ui-widget-content ui-corner-left ' + this._getInheritedClasses('input') + '" id="' + this._ids.input + '" value="" />')
				.val(this.parentField.val() ? this.parentField.text() : '')
				.appendTo(this.wrapper);

			if(this.options.onlySelect){
				this.input.attr('readonly', true);
			}

			// Button Element
			this.button = $('<button type="button" class="combobox combobox-button ' + this._getInheritedClasses('button') + '" id="' + this._ids.button + '">&nbsp;</button>')
				.attr('tabIndex', -1)
				.prop('title', this.parentField.prop('title'))
				.appendTo(this.wrapper)
				.button({
					icons: {
						secondary: 'ui-icon-triangle-1-s'
					},
					text: false
				})
				.removeClass('ui-corner-all')
				.addClass('ui-corner-right ui-button-icon');

			if(this.parentField.is(':disabled')){
				this.disable();
			}

            if(this.parentField.is('[activehelp]')) {
                this.wrapper.alerts('add', 'help', {id:'activehelp',message:this.parentField.attr('activehelp')}, false);
            }

			// Display the content in print view
			this.area = $('<div class="text-printview print-only" />').html(this.parentField.val() ? this.parentField.find('option:selected').text() : '');
			this.input.addClass('no-print');

			this.area.css({
				'min-width': this.input.css('width'),
				'min-height': '12px'
			});
			this.input.after(this.area);
		},

		/**
		 * Return a filter string used to filter the contents of the select box
		 */
		_sourceFilter: function(){
			return this.options.sourceFilter + ':not(".blank")';
		},

		/**
		 * Will build & assign the source filter function to autocomplete
		 */
		_buildSourceFunc: function(){
			// Make sure the parentSelector has the required extra elements
			if(this.options.canHaveEmpty && this.parentField.children('option[value="__empty"]').length == 0)
				this.parentField.append('<option value="__empty" class="blank"></option>');

			if(this.options.canHaveNew && this.parentField.children('option[value="__new"]').length == 0)
				this.parentField.append('<option value="__new" class="blank"></option>');

			// Assign the information to the autocomplete box
			this.input.data('autocomplete').cbb_parentField = this.parentField; // jQuery Object
			this.input.data('autocomplete').cbb_sourceFilter = this._sourceFilter(); // Function returning string
			this.input.data('autocomplete').cbb_filterFunc = this.options.filter; // Function or Bool filtering
			this.input.data('autocomplete').cbb_options = this.options; // Function or Bool filtering
			this.input.data('autocomplete').cbb_validation = this._acValidationFunction; // Function or Bool filtering
			this.input.data('autocomplete').cbb_button = this.button; // button object
			this.input.data('autocomplete')._renderMenu = ($.isFunction(this.options.renderMenu)) ? this.options.renderMenu : this._acRenderMenu;
			this.input.data('autocomplete')._renderItem = ($.isFunction(this.options.renderItem)) ? this.options.renderItem : this._acRenderItem;
		},

        /**
         * Autocomplete Source Function
         */
        _acSourceFunction: function(request, response){
            // Scope of Autocomplete
            var matcher = new RegExp( $.ui.autocomplete.escapeRegex(request.term), "i" );

            this.cbb_parentField.find('optgroup').each(function(){
                if($(this).find('option').length == 0)
                    $(this).append('<option class="skipme"></option>');
            });

            var options = this.cbb_parentField.find(this.cbb_sourceFilter);
            var sourceStuff = [];
            options.each(function(){
                var text = $('<div/>').html($(this).text()).text();

                if($(this).attr('style')){
                    text = '<span style="' + $(this).attr('style') + '">' + text + '</span>';
                }

                if(this.value && (!request.term || matcher.test($(this).text()))){
                    sourceStuff.push({
                        label: text.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + $.ui.autocomplete.escapeRegex(request.term) + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<strong>$1</strong>"),
                        value: text,
                        option: this,
                        category: $(this).parent('optgroup').attr('label'),
                        title: $(this).attr('title'),
                        skipme: $(this).is('.skipme'),
                        help: $(this).is('[activehelp]') ? $(this).attr('activehelp') : '',
                        data: $(this).data()
                    });
                }
            });

            if(sourceStuff.length == 0){
                sourceStuff = this.cbb_parentField.children('option.blank:first').map(function(){
                    return {
                        label: '',
                        value: '__none',
                        option: this
                    };
                });
            }

            response(sourceStuff);
        },

		/**
		 * Autocomplete Validation Function
		 */
		_acValidationFunction: function(event, ui){
			// Scope of Autocomplete
			// If no options were passed then the selected text doesn't exist!
			// Otherwise there was a matching option, so all is good in the world
			if(!ui.item){
				// Grab the value
				var returnValue = this.element.val();

				// In this case we need to validate it against the provided filter function
				// This function should return a string to fill the textbox or a null to clear it
				if(this.cbb_filterFunc != false && $.isFunction(this.cbb_filterFunc)){
					returnValue = this.cbb_filterFunc(returnValue);
				}

				// Is it empty?
				if(returnValue == null || returnValue.length == 0){
					// Are we allowing empty?
					if(!this.cbb_options.canHaveEmpty){
						// No
						this.cbb_parentField.children(this.cbb_sourceFilter + ':first').attr('selected', 'selected');
						this.element.val(this.cbb_parentField.find('option:selected').text());
					}
					else {
						// Yes
						this.cbb_parentField.val('__empty');
						this.element.val('');
					}
				}
				// Not empty
				else {
					// Are we allowing it new?
					if(!this.cbb_options.canHaveNew){
						// No
						// Reset to EMPTY if can have empty
						if(this.cbb_options.canHaveEmpty){
							this.cbb_parentField.val('__empty');
							this.element.val('');
						}
						else{
							this.cbb_parentField.children(this.cbb_sourceFilter + ':first').attr('selected', 'selected');
							this.element.val(this.cbb_parentField.find('option:selected').text());
						}
					}
					else {
						// Yes
						this.cbb_parentField.val('__new');
						this.element.val(returnValue);
					}
				}

				// Do a final check to make sure the new value doesn't already exist
				if(this.cbb_parentField.find('option[text="' + returnValue + '"]:not(".blank")').text().length > 0){
					// Yes it does
					this.cbb_parentField.find('option[text="' + returnValue + '"]:not(".blank")').attr('selected', 'selected');
				}
			}

			// Trigger the passed in change function
			if($.isFunction(this.cbb_options.change)){
				this.cbb_options.change(event, ui);
			}
        },

        /**
         * Autocomplete Menu Rendering Function
         * @param ul
         * @param items
         */
        _acRenderMenu: function(ul, items){

            // Scope of Autocomplete
            if(items.length == 1 && items[0].value == '__none'){
                // No items exist
                if(this.cbb_options.label.blank.length > 0)
                    $('<li class="autoheader">' + this.cbb_options.label.blank + '</li>').prependTo(ul);
            }
            else {
                var self = this,
                    currentCategory = undefined;
                $.each(items, function(index, item){
                    if(currentCategory != item.category){
                        if(item.category != undefined)
                            $('<li class="ui-menu-item ui-autocomplete-category" role="menuitem">' + item.category + '</li>').appendTo(ul);
                        currentCategory = item.category;
                    }
                    if($.trim(item.label).length == 0)
                        item.label = '&nbsp;';

                    if(!item.skipme)
                        self._renderItem(ul, item);
                });

                if(this.cbb_options.label.head.length > 0)
                    $('<li class="autoheader">' + this.cbb_options.label.head + '</li>').prependTo(ul);

                if(this.cbb_options.label.foot.length > 0)
                    $('<li class="autoheader">' + this.cbb_options.label.foot + '</li>').appendTo(ul);

                ul.removeClass('ui-corner-all')
                    .addClass('ui-corner-bottom');
            }
        },

        /**
         * Autocomplete Item Rendering Function
         * @param ul
         * @param item
         */
        _acRenderItem: function(ul, item){
            // Scope of Autocomplete
            var thisClass = '',
                itemClass = $(item.option).attr('class');

            if(this.cbb_options.inheritClasses === true && typeof itemClass !== 'undefined')
            {
                thisClass += ' ' + itemClass;
            }

            if(this.cbb_options.titleMode){
                return $('<li ' + (item.help.length > 0 ? ' activehelp="' + item.help + '"' : '') + '></li>')
                    .data('item.autocomplete', item)
                    .addClass(thisClass)
                    .append('<a>' + item.title + '</a>')
                    .appendTo(ul);
            }
            else {
                return $('<li ' + (item.help.length > 0 ? ' activehelp="' + item.help + '"' : '') + '></li>')
                    .data('item.autocomplete', item)
                    .addClass(thisClass)
                    .append('<a>' + item.label + '</a>')
                    .appendTo(ul);
            }
        },

		/**
		 * Refresh the element and build from the source
		 */
		refresh: function(){
			this._sourceFilter(); // TODO: doesn't actually do anything
			this._buildDefaultMessages();
			this._buildSourceFunc();

			if(this.input.autocomplete('widget').is(':visible')){
				this.input.autocomplete('close');
				this.input.autocomplete('open');
			}
		},

		/**
		 * Hide or show the parent selector
		 */
		toggle: function(){
			this.parentField.toggle();
		},

		/**
		 * Disable the combo box
		 */
		disable: function(){
			this.parentField.attr('disabled', 'disabled');
			this.input.attr('disabled', 'disabled').addClass('disabled');
			this.button.attr('disabled', 'disabled').addClass('disabled').button('refresh');
		},

		/**
		 * Enable the combo box
		 */
		enable: function(){
			this.parentField.removeAttr('disabled');
			this.input.removeAttr('disabled').removeClass('disabled');
			this.button.removeAttr('disabled').removeClass('disabled').button('refresh');
		},

		/**
		 * Close the menu
		 */
		close: function(){
			this.input.autocomplete('close');
		},

		/**
		 * Open the combobox menu
		 */
		open: function(){
			this.input.autocomplete('search', '');
		},

		/**
		 * Destroy the entire combobox
		 */
		destroy: function(){
			// call widget destroy function
			$.Widget.prototype.destroy.apply(this, arguments);
			this.input.remove();
			this.button.remove();
			this.parentField.removeClass('combo_d').show();
		},

		// Get the reference to the specific field
		get: function(field){
			if(field == 'button') return this.button;
			else if(field == 'input') return this.input;
			else return this.selectParent;
		},

		/**
		 * Call this.val() to get the current value
		 */
		getValue: function(){
			return this.val();
		},

		/**
		 * Get the current value
		 */
		val: function(){
			if(this.parentField.find('option:selected').val() == '__new'){
				return this.input.val();
			}
			else if(this.parentField.find('option:selected').val() == '__blank'){
				return '';
			}
			else {
				return this.parentField.find('option:selected').val();
			}
		},

		/**
		 * Force the selector back to the selected item (override anything user-entered)
		 */
		refreshText: function(){
			var text = $('<div/>').html(this.parentField.find('option:selected').text()).text();
			this.input.val(text);
		},

		// Deprecated functions
		selectFirst: function(){
			console.log('comboBox.selectFirst() is deprecated, use refreshText instead');
			this.refreshText();
		},

		setVal: function(val){
			this.parentField.find('option[value="' + val + '"]').attr('selected', 'selected');
			this.refresh();
			this.refreshText();
		}
	});
})(jQuery);
